import { useState } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import toast from 'react-hot-toast';
import api from '../utils/api';
import '../styles/Pages.css';

function ContactUs() {
    const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post('/contact', { ...form, type: 'general' });
            toast.success('Message sent! We will get back to you within 2–3 working days.');
            setForm({ name: '', email: '', phone: '', subject: '', message: '' });
        } catch {
            toast.error('Failed to send. Please email us directly at info@shrimulikadevicollege.com');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Contact Us</p>
                <h1>Contact Us</h1>
                <p>We're here to help — reach us by phone, email, or visit us in person.</p>
            </div>
            <div className="page-content">
                <div className="contact-grid" style={{ marginBottom: '2rem' }}>
                    <div className="contact-card">
                        <div className="icon">📍</div>
                        <h4>Address</h4>
                        <p>Shri Mulikadevi Mahavidyalaya, Nighoj<br />Tal. Parner, Dist. Ahmednagar<br />Maharashtra</p>
                    </div>
                    <div className="contact-card">
                        <div className="icon">📞</div>
                        <h4>Phone / Fax</h4>
                        <a href="tel:02488230438"><p>(02488) 230438</p></a>
                        <p style={{ fontSize: '0.82rem', color: '#999' }}>Fax: (02488) 230438</p>
                    </div>
                    <div className="contact-card">
                        <div className="icon">✉️</div>
                        <h4>Email</h4>
                        <a href="mailto:ascnighoj@gmail.com"><p>ascnighoj@gmail.com</p></a>
                        <a href="mailto:info@shrimulikadevicollege.com"><p>info@shrimulikadevicollege.com</p></a>
                    </div>
                    <div className="contact-card">
                        <div className="icon">💬</div>
                        <h4>WhatsApp</h4>
                        <a href="https://api.whatsapp.com/send?phone=919102488230438&text=Hi!" target="_blank" rel="noreferrer">
                            <p>+91 9102488230438</p>
                        </a>
                    </div>
                    <div className="contact-card">
                        <div className="icon">🕐</div>
                        <h4>Office Hours</h4>
                        <p>Mon–Sat: 9:00 AM – 5:00 PM<br />Sunday: Closed</p>
                    </div>
                    <div className="contact-card">
                        <div className="icon">📘</div>
                        <h4>Social Media</h4>
                        <a href="https://www.facebook.com/shrimulikadevicolleges" target="_blank" rel="noreferrer"><p>Facebook Page</p></a>
                    </div>
                </div>

                {/* Google Maps — same embed as official site */}
                <div className="info-card">
                    <h2>Find Us on Map</h2>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106794.80152750545!2d74.22111608627166!3d18.967663244111872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdcd416a2c67fc9%3A0xb0ee879457796c9b!2sShri%20Mulikadevi%20Mahavidyalaya%2C%20Nighoj!5e0!3m2!1sen!2sin!4v1731675533155!5m2!1sen!2sin"
                        style={{ border: 0, width: '100%', height: '400px', borderRadius: '10px' }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="College Location Map"
                    />
                </div>

                {/* Contact Form */}
                <div className="form-box" style={{ marginTop: '1.5rem' }}>
                    <h2 style={{ color: '#1a3c5e', marginBottom: '1.2rem', fontSize: '1.2rem' }}>Send Us a Message</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Full Name *</label>
                                <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
                            </div>
                            <div className="form-group">
                                <label>Email *</label>
                                <input type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Phone</label>
                                <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Mobile number" />
                            </div>
                            <div className="form-group">
                                <label>Subject *</label>
                                <input required value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} placeholder="e.g. Admission inquiry" />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Message *</label>
                            <textarea required value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Write your message..." rows={5} />
                        </div>
                        <button type="submit" className="submit-btn" disabled={submitting}>
                            {submitting ? 'Sending…' : '📩 Send Message'}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default ContactUs;
